<template>
  <div>
    <v-layout wrap justify-center fill-height>
      <v-flex xs12 sm12 md12 lg2 hidden-md-and-down>
        <v-navigation-drawer
          class="fixedSidebar custom-scrollbar"
          v-model="sideNav"
          clipped
          dark
          width="100%"
          height="100vh"
          permanent
          color="#005f32"
        >
          <v-layout wrap>
            <v-flex xs12 text-center py-4>
              <router-link to="/">
                <v-img contain height="80px" :src="require('./../../public/wtilogo.png')" />
              </router-link>
            </v-flex>

            <v-flex xs12 text-left py-2 align-self-center>
              <v-list dense class="sidebar-list">
                <div
                  v-for="(main, i) in restructuredAppMenu"
                  :key="i"
                  class="menu-wrapper"
                  @mouseenter="setHover(i)"
                  @mouseleave="clearHover(i)"
                >
                  <router-link
                    v-if="main.name === 'Dashboard'"
                    :to="main.route"
                    class="menu-link"
                  >
                    <v-list-item class="main-menu-item" :class="{'active-main': $route.path === main.route}">
                      <v-list-item-icon class="mr-3">
                        <v-icon :color="$route.path === main.route ? '#005f32' : 'white'">{{ main.icon }}</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="menu-title" :style="{'color': $route.path === main.route ? '#005f32' : 'white'}">
                          {{ main.name }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </router-link>

                  <div v-else>
                    <v-list-item 
                      class="main-menu-item" 
                      :class="{
                        'active-main': hoveredMenu === i || isActiveMenu(main),
                        'has-submenus': hoveredMenu === i && main.submenus && main.submenus.length > 0
                      }"
                    >
                      <v-list-item-icon class="mr-3">
                        <v-icon :color="hoveredMenu === i || isActiveMenu(main) ? '#005f32' : 'white'">{{ main.icon }}</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="menu-title" :style="{'color': hoveredMenu === i || isActiveMenu(main) ? '#005f32' : 'white'}">
                          {{ main.name }}
                        </v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-icon :color="hoveredMenu === i || isActiveMenu(main) ? '#005f32' : 'white'" small>
                          {{ hoveredMenu === i ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                        </v-icon>
                      </v-list-item-action>
                    </v-list-item>

                    <v-expand-transition>
                      <div v-show="hoveredMenu === i">
                        <div class="submenu-container">
                          <div class="submenu-card">
                          <template v-for="(sub, j) in main.submenus">
                            <!-- if level 2 has level 3 items -->
                            <v-list-group
                              v-if="sub.submenus && sub.submenus.length > 0"
                              :key="j"
                              no-action
                              sub-group
                              class="level2-group"
                              :value="openSubGroup === `${i}-${j}`"
                              @input="val => openSubGroup = val ? `${i}-${j}` : null"
                            >
                              <template v-slot:activator>
                                <v-list-item-content>
                                  <v-list-item-title class="sub-menu-title">{{ sub.name }}</v-list-item-title>
                                </v-list-item-content>
                              </template>
                              
                              <v-list-item
                                v-for="(subSub, k) in sub.submenus"
                                :key="k"
                                :to="subSub.route"
                                class="level3-item"
                                active-class="activated-sub"
                              >
                                <v-list-item-content>
                                  <v-list-item-title class="subsub-menu-title">{{ subSub.name }}</v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list-group>

                            <!-- if level 2 is just a link -->
                            <v-list-item
                              v-else
                              :key="j"
                              :to="sub.route || '/'"
                              class="level2-item"
                              active-class="activated-sub"
                            >
                              <v-list-item-content>
                                <v-list-item-title class="sub-menu-title">{{ sub.name }}</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </template>
                        </div>
                      </div>
                      </div>
                    </v-expand-transition>
                  </div>
                </div>
              </v-list>
            </v-flex>
          </v-layout>
        </v-navigation-drawer>
      </v-flex>
      <v-flex xs12 sm12 md12 lg10>
        <AppHeader />
        <v-divider></v-divider>
        <v-layout
          wrap
          justify-center
          :style="
            $route.name == 'Dashboard'
              ? 'background-color: #FFFFFF'
              : 'background-color: #F5F5DC'
          "
        >
          <v-flex xs12 pa-6>
            <v-card
              tile
              min-height="100vh"
              :color="$route.name == 'Dashboard' ? 'transparent' : '#FFFFFF'"
              :flat="$route.name == 'Dashboard' ? true : false"
            >
              <v-layout wrap justify-center>
                <v-flex xs12 pa-4>
                  <router-view :key="$route.fullPath"></router-view>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import AppHeader from "./../layout/AppHeader";
export default {
  components: {
    AppHeader,
  },
  data() {
    return {
      sideNav: true,
      hoveredMenu: null,
      hoverTimer: null,
      openSubGroup: null,
      admin: [{ name: "ADMINS", route: "/Admins" }],

      NewEmpMenu: [
        {
          menu: {
            name: "Dashboard",
          },
          submenus:[
            {
              route:"/",
              name:"Dashboard"
            }

          ]
        },
        // {
        //   menu: {
        //     name: "Forms",
        //   },
        //   submenus:[
        //     {
        //       route:"/YourApplications",
        //       name:"Forms & Policies"
        //     }

        //   ]
        // },
      ],

      menus: [
        {
          name: "Dashboard",
          subMenu: [
            {
              name: "Dashboard",
              route: "/",
            },
          ],
        },

        {
          name: "Category",
          subMenu: [
            {
              name: "Category List",
              route: "/CategoryList",
            },
          ],
        },
        {
          name: "Job Title",
          subMenu: [
            {
              name: "Title List",
              route: "/TitleList",
            },
          ],
        },

        {
          name: "Volunteer Title",
          subMenu: [
            {
              name: "Title List",
              route: "/Volunteer",
            },
          ],
        },
        {
          name: "Job Applications",
          subMenu: [
            {
              name: "Applications",
              route: "/Applications",
            },
          ],
        },
        {
          name: "Volunteer Applications",
          subMenu: [
            {
              name: "Volunteer Applications",
              route: "/volunteerApplication",
            },
          ],
        },
        {
          name: "Employee ",
          subMenu: [
            {
              name: "Employee Document",
              route: "/employeedocument",
            },
            {
              name: "Employee List",
              route: "/employeelist",
            },
          ],
        },

        {
          name: "Products",
          subMenu: [
            {
              name: "Products",
              route: "/products",
            },
            {
              name: "Add Product",
              route: "/addProducts",
            },

            {
              name: "Add Product-Type",
              route: "/ProductType",
            },
            {
              name: "Promocode",
              route: "/promocode",
            },
          ],
        },
        {
          name: "Purchase",
          subMenu: [
            {
              name: "Purchase",
              route: "/purchaseReports",
            },
          ],
        },
        {
          name: "HomePage",
          subMenu: [
            {
              name: "About us",
              route: "/aboutUs",
            },
            {
              name: "Video",
              route: "/Video",
            },
            {
              name: "Announcements",
              route: "/Announcements",
            },
          ],
        },
        {
          name: "WTI Contest",
          subMenu: [
            {
              name: "Applications",
              route: "/quizDetails",
            },
          ],
        },
        {
          name: "Conservation Clock",
          subMenu: [
            {
              name: "Conservation Clock",
              route: "/conservationClock",
            },
          ],
        },
        {
          name: "Settings",
          subMenu: [
            {
              name: "Roles",
              route: "/Roles",
            },
            {
              name: "Departments",
              route: "/Departments",
            },
            {
              name: "Projects",
              route: "/Projects",
            },
            {
              name: "Positions",
              route: "/Positions",
            },
            
          ],
        },
      ],
    };
  },
  methods: {
    setHover(i) {
      if (this.hoverTimer) {
        clearTimeout(this.hoverTimer);
        this.hoverTimer = null;
      }
      this.hoveredMenu = i;
    },
    clearHover(i) {
      this.hoverTimer = setTimeout(() => {
        if (this.hoveredMenu === i) {
          this.hoveredMenu = null;
        }
      }, 150); // 150ms delay to prevent layout thrashing and flickering
    },
    isActiveMenu(main) {
      if (!main.submenus) return false;
      return main.submenus.some(sub => {
        if (sub.route === this.$route.path) return true;
        if (sub.submenus) {
          return sub.submenus.some(ss => ss.route === this.$route.path);
        }
        return false;
      });
    }
  },
  computed: {
    restructuredAppMenu() {
      const safeMerge = (targetArr, newItems) => {
        newItems.forEach(item => {
          const iName = ((item.menu && item.menu.name) || item.name || "").toLowerCase().trim();
          const iRoute = (item.route || "").toLowerCase().trim();
          const exists = targetArr.find(e => {
            const eName = ((e.menu && e.menu.name) || e.name || "").toLowerCase().trim();
            const eRoute = (e.route || "").toLowerCase().trim();
            if (iRoute && eRoute === iRoute) return true;
            if (iName && eName === iName && iName !== "") return true;
            return false;
          });
          if (!exists) targetArr.push(item);
        });
      };
      const menus = this.appMenu || [];
      const structure = [
        { name: "Dashboard", icon: "mdi-view-dashboard", submenus: [], route: "/" },
        { name: "Employee Onboarding", icon: "mdi-account-check", submenus: [] },
        { name: "Recruitment & Onboarding", icon: "mdi-account-plus", submenus: [] },
        { name: "Time Management", icon: "mdi-clock-check-outline", submenus: [] },
        { name: "Employee Master Data", icon: "mdi-card-account-details-outline", submenus: [] },
        { name: "Performance Management", icon: "mdi-bullseye-arrow", submenus: [] },
        { name: "Payroll Management", icon: "mdi-cash-multiple", submenus: [] },
        { name: "HR Downloads", icon: "mdi-folder-download-outline", submenus: [
          { name: "Downloads", route: "/download" }
        ] },
        { name: "Settings", icon: "mdi-cog-outline", submenus: [] },
        { name: "Technical Support", icon: "mdi-headset", submenus: [] },
        { name: "Others", icon: "mdi-dots-horizontal", submenus: [] }
      ];

      const categoryMap = {
        "job title": "Recruitment & Onboarding",
        "job applications": "Recruitment & Onboarding",
        "category": "Recruitment & Onboarding",
        
        "orientation": "Employee Onboarding",
        
        "volunteer title": "Others",
        "volunteer applications": "Others",
        
        "attendance": "Time Management",
        "leave management": "Time Management",
        "travelogue": "Time Management",
        
        "employee": "Employee Master Data",
        "employee list": "Employee Master Data",
        "teams": "Employee Master Data",
        "team": "Employee Master Data",
        "employee comparison": "Employee Master Data",
        "exit management": "Employee Master Data",
        
        "targets": "Performance Management",
        "pmr": "Performance Management",
        
        "payslips": "Payroll Management",
        "loans & advances": "Payroll Management",
        
        "downloads": "HR Downloads",
        "excel reports": "HR Downloads",
        "hrmanual": "HR Downloads",
        "hr manual": "HR Downloads",
        "hr manuals": "HR Downloads",
        
        "settings": "Settings",
        "organization details": "Settings",
        
        "troubleshoot": "Technical Support",
      };

      menus.forEach(main => {
        const rawName = (main.menu && main.menu.name) ? main.menu.name : (main.name || "");
        const oldName = rawName.toLowerCase().trim();
        
        if (oldName === "download" || oldName === "downloads") {
          return;
        }

        if (oldName === "dashboard" || oldName === "home") {
          return; // Handled directly
        }
        
        if (oldName === "attendance") {
          const attendanceItems = [];
          const leaveItems = [];
          const travelItems = [];
          const subs = main.submenus || main.subMenu || [];
          
          subs.forEach(sub => {
            const subName = (sub.name || "").toLowerCase();
            if (subName.includes("leave") || subName.includes("withdraw")) {
              leaveItems.push(sub);
            } else if (subName.includes("travel")) {
              travelItems.push(sub);
            } else {
              attendanceItems.push(sub);
            }
          });
          
          const cat = structure.find(s => s.name === "Time Management");
          if (cat) {
            if (attendanceItems.length > 0) {
              const existing = cat.submenus.find(s => s.name.toLowerCase() === "attendance");
              if (existing) {
                safeMerge(existing.submenus, attendanceItems);
                if (!existing.route && main.route) existing.route = main.route;
              } else {
                cat.submenus.push({
                  name: "Attendance",
                  submenus: [...attendanceItems],
                  route: main.route
                });
              }
            }
            if (leaveItems.length > 0) {
              const existing = cat.submenus.find(s => s.name.toLowerCase() === "leave management");
              if (existing) {
                safeMerge(existing.submenus, leaveItems);
              } else {
                cat.submenus.push({
                  name: "Leave Management",
                  submenus: [...leaveItems],
                  route: null
                });
              }
            }
            if (travelItems.length > 0) {
              const existing = cat.submenus.find(s => s.name.toLowerCase() === "travelogue");
              if (existing) {
                safeMerge(existing.submenus, travelItems);
              } else {
                cat.submenus.push({
                  name: "Travelogue",
                  submenus: [...travelItems],
                  route: null
                });
              }
            }
          }
          return;
        }

        if (oldName === "employee" || oldName === "employees") {
          const subs = main.submenus || main.subMenu || [];
          const allLinks = [];
          const extractLinks = (items) => {
            items.forEach(item => {
              if (item.submenus && item.submenus.length > 0) {
                 extractLinks(item.submenus);
              } else {
                 allLinks.push(item);
              }
            });
          };
          extractLinks(subs);

          const employeeListGroup = [];
          const teamsGroup = [];
          const comparisonGroup = [];
          const exitGroup = [];
          const hrDownloadsGroup = [];
          const othersGroup = [];

          allLinks.forEach(link => {
            const name = (link.name || "").toLowerCase();
            if (name.includes("team")) {
              teamsGroup.push(link);
            } else if (name.includes("comparison")) {
              comparisonGroup.push(link);
            } else if (name.includes("exit") || name.includes("resigned")) {
              exitGroup.push(link);
            } else if (name.includes("forms") || name.includes("policies")) {
              hrDownloadsGroup.push(link);
            } else if (name.includes("document") || name.includes("doc")) {
              othersGroup.push(link);
            } else {
              employeeListGroup.push(link);
            }
          });

          const cat = structure.find(s => s.name === "Employee Master Data");
          if (cat) {
             if (employeeListGroup.length > 0) {
               cat.submenus.push({ name: "Employee List", submenus: employeeListGroup, route: null });
             }
             if (teamsGroup.length > 0) {
               cat.submenus.push({ name: "Teams", submenus: teamsGroup, route: null });
             }
             if (comparisonGroup.length > 0) {
               cat.submenus.push({ name: "Employee Comparison", submenus: comparisonGroup, route: null });
             }
             if (exitGroup.length > 0) {
               let exitSub = cat.submenus.find(s => s.name === "Exit Management");
               if (exitSub) {
                 exitSub.submenus.push(...exitGroup);
               } else {
                 cat.submenus.push({ name: "Exit Management", submenus: exitGroup, route: null });
               }
             }
          }

          const hrCat = structure.find(s => s.name === "HR Downloads");
          if (hrCat && hrDownloadsGroup.length > 0) {
            hrDownloadsGroup.forEach(link => {
              hrCat.submenus.push({ name: link.name, submenus: link.submenus || [], route: link.route });
            });
          }

          const othersCat = structure.find(s => s.name === "Others");
          if (othersCat && othersGroup.length > 0) {
            othersGroup.forEach(link => {
              othersCat.submenus.push({ name: link.name, submenus: link.submenus || [], route: link.route });
            });
          }
          return;
        }

        if (oldName === "exit interview") {
          const cat = structure.find(s => s.name === "Employee Master Data");
          if (cat) {
            let exitSub = cat.submenus.find(s => s.name === "Exit Management");
            if (exitSub) {
              exitSub.submenus.push({
                 name: rawName,
                 submenus: main.submenus || main.subMenu || [],
                 route: main.route
              });
            } else {
              cat.submenus.push({
                 name: "Exit Management",
                 submenus: [{ name: rawName, submenus: main.submenus || main.subMenu || [], route: main.route }],
                 route: null
              });
            }
          }
          return;
        }

        const newCategoryName = categoryMap[oldName] || "Others";
        const cat = structure.find(s => s.name === newCategoryName);
        if (cat) {
          const existingSub = cat.submenus.find(s => s.name.toLowerCase() === rawName.toLowerCase());
          const newSubs = main.submenus || main.subMenu || [];
          if (existingSub) {
            safeMerge(existingSub.submenus, newSubs);
            if (!existingSub.route && main.route) existingSub.route = main.route;
          } else {
            cat.submenus.push({
              name: rawName,
              submenus: [...newSubs],
              route: main.route
            });
          }
        }
      });

      const recCat = structure.find(s => s.name === "Recruitment & Onboarding");
      if (recCat) {
        const orderMap = {
          "job title": 1,
          "volunteer title": 2,
          "job application": 3,
          "job applications": 3,
          "volunteer applications": 4,
          "orientation": 5,
          "category": 6
        };
        recCat.submenus.sort((a, b) => {
          const nameA = (a.name || "").toLowerCase().trim();
          const nameB = (b.name || "").toLowerCase().trim();
          const orderA = orderMap[nameA] || 99;
          const orderB = orderMap[nameB] || 99;
          return orderA - orderB;
        });
      }

      const timeCat = structure.find(s => s.name === "Time Management");
      if (timeCat) {
        const timeOrderMap = {
          "attendance": 1,
          "leave management": 2,
          "travelogue": 3
        };
        timeCat.submenus.sort((a, b) => {
          const nameA = (a.name || "").toLowerCase().trim();
          const nameB = (b.name || "").toLowerCase().trim();
          const orderA = timeOrderMap[nameA] || 99;
          const orderB = timeOrderMap[nameB] || 99;
          return orderA - orderB;
        });
      }

      const empCat = structure.find(s => s.name === "Employee Master Data");
      if (empCat) {
        const empOrderMap = {
          "employee list": 1,
          "teams": 2,
          "team": 2,
          "employee comparison": 3,
          "exit management": 4
        };
        empCat.submenus.forEach(sub => {
           const lowerName = (sub.name || "").toLowerCase().trim();
           if (lowerName === "employee list") sub.name = "Employee List";
           if (lowerName === "teams" || lowerName === "team") sub.name = "Teams";
           if (lowerName === "employee comparison") sub.name = "Employee Comparison";
           if (lowerName === "exit management") sub.name = "Exit Management";
        });
        empCat.submenus.sort((a, b) => {
          const nameA = (a.name || "").toLowerCase().trim();
          const nameB = (b.name || "").toLowerCase().trim();
          const orderA = empOrderMap[nameA] || 99;
          const orderB = empOrderMap[nameB] || 99;
          return orderA - orderB;
        });
      }

      const hrCatSort = structure.find(s => s.name === "HR Downloads");
      if (hrCatSort) {
        const hrOrderMap = {
          "downloads": 1,
          "forms & policies": 2,
          "hrmanual": 3,
          "hr manuals": 3,
          "hr manual": 3
        };
        hrCatSort.submenus.sort((a, b) => {
          const nameA = (a.name || "").toLowerCase().trim();
          const nameB = (b.name || "").toLowerCase().trim();
          const orderA = hrOrderMap[nameA] || 99;
          const orderB = hrOrderMap[nameB] || 99;
          return orderA - orderB;
        });
      }

      const payrollCatSort = structure.find(s => s.name === "Payroll Management");
      if (payrollCatSort) {
        const payrollOrderMap = {
          "payslips": 1,
          "loans & advances": 2
        };
        payrollCatSort.submenus.sort((a, b) => {
          const nameA = (a.name || "").toLowerCase().trim();
          const nameB = (b.name || "").toLowerCase().trim();
          const orderA = payrollOrderMap[nameA] || 99;
          const orderB = payrollOrderMap[nameB] || 99;
          return orderA - orderB;
        });
      }

      const ut = (this.$store.state.userType || "").toLowerCase();
      const st_role = (this.$store.state.role || "").toLowerCase();
      const ud_role = (this.$store.state.userData && this.$store.state.userData.role || "").toLowerCase();
      const ud_usertype = (this.$store.state.userData && this.$store.state.userData.usertype || "").toLowerCase();
      const ud_name = (this.$store.state.userData && this.$store.state.userData.name || "").toLowerCase();
      const ls_type = (localStorage.getItem("userType") || "").toLowerCase();

      const isAdmin = [ut, st_role, ud_role, ud_usertype, ud_name, ls_type].some((s) =>
          s.includes("admin") || s.includes("super") || s.includes("hr") || s.includes("management") || s.includes("panel")
      );

      return structure.filter(c => {
        if (c.name === "Dashboard") return true;
        if (c.name === "Others" && !isAdmin) return false;
        if (c.name === "Employee Onboarding" && isAdmin) return false;
        if (c.name === "Employee Master Data" && !isAdmin) return false;
        return c.submenus.length > 0;
      });
    },
    appType() {

      return this.$store.state.userType;
    },
    appMenu() {
      // console.log("menus", store.state.menus);
      if (this.$store.state.menus.length > 0 && this.$store.state.positionId != null) {
        return this.$store.state.menus;
      } else {
        return this.NewEmpMenu;
      }
    },
    navItems() {
      if (this.appType == "subadmin") return this.userNavItemsSubAdmin;
      else if (this.appType == "programadmin")
        return this.userNavItemsProgramAdmin;
      else if (this.appType == "staticcontentadmin")
        return this.userNavItemsStaticAdmin;
      else if (this.appType == "accountsadmin")
        return this.userNavItemsAccountsAdmin;
      else return this.userNavItems;
    },
  },
};
</script>
<style>
@media only screen and (min-device-width: 767px) {
  .fixedSidebar {
    /* position: fixed; */

    position: -webkit-sticky; /* Safari */
    position: sticky;
    top: 50;
  }
}
@media only screen and (min-device-width: 360px) and (max-device-width: 640px) {
  .fixedSidebar {
    display: none !important;
  }
}
.activated {
  color: rgb(240, 115, 5) !important;
}
.deactivated {
  color: rgb(240, 115, 5) !important;
}

.menu-wrapper {
  position: relative;
  padding-bottom: 6px;
}
.main-menu-item {
  border-radius: 8px;
  margin: 0 12px;
  padding: 8px 16px;
  transition: all 0.2s;
  border: 1px solid transparent;
}
.main-menu-item.active-main {
  background-color: #e4efe7 !important;
  color: #005f32 !important;
  border: 1px solid #b5cbbd;
  border-bottom: 3px solid #b5cbbd;
  z-index: 2;
  position: relative;
}
.main-menu-item.active-main.has-submenus {
  border-bottom: 0px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.menu-link {
  text-decoration: none;
}
.menu-title {
  font-family: kumbhMedium;
  font-size: 14px;
  letter-spacing: 0.5px;
  white-space: normal !important;
  line-height: 1.2;
}
.submenu-container {
  padding: 0 12px;
  margin-top: -1px;
  position: relative;
  z-index: 1;
}
.submenu-card {
  background-color: #e4efe7;
  border-radius: 0 0 8px 8px;
  padding: 4px 0 8px 0;
  border: 1px solid #b5cbbd;
  border-top: none;
  border-bottom: 3px solid #b5cbbd;
}
.submenu-card::before {
  content: '';
  display: block;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(0,95,50,0.15), transparent);
  margin: 0 12px 8px 12px;
}
.submenu-card .v-list-item__title {
  color: #005f32 !important;
}
.submenu-card .v-icon {
  color: #005f32 !important;
}
.sub-menu-title {
  font-family: kumbhMedium;
  font-size: 13px;
  white-space: normal !important;
  line-height: 1.2;
}
.subsub-menu-title {
  font-family: kumbhRegular;
  font-size: 12px;
  white-space: normal !important;
  line-height: 1.2;
}
.level2-item, .level2-group {
  margin-bottom: 2px;
}
.activated-sub {
  background-color: rgba(0, 95, 50, 0.1);
}
.activated-sub .sub-menu-title,
.activated-sub .subsub-menu-title,
.activated-sub .v-icon {
  color: #005f32 !important;
  font-family: kumbhEBold;
}
.custom-scrollbar {
  overflow-y: auto;
}
.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
}
.custom-scrollbar::-webkit-scrollbar-track {
  background: transparent;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 3px;
}
</style>
